/**
 * usePendingSlotChange — la demande « Modifier mes créneaux » qui attend son issue, pour l'enfant affiché : la carte
 * « Demandes en cours » de l'accueil et la ligne du portail la lisent (`GET student-slot-change/pending`). Relue à
 * chaque retour sur l'écran : la demande avance sans lui (une réponse du tuteur, la cohorte).
 */
import { useFocusEffect } from "@react-navigation/native"
import { useCallback, useEffect, useState } from "react"

import { studentSlotChangeService } from "../../../../data/services/studentSlotChangeService"
import { toUISlotChangePending, type ApiSlotChangePending } from "../../adapters/parent/SlotChange/slotChangeAdapter"
import { type UISlotChangePending } from "../types"
import { useApiFetch } from "./useApiFetch"

export function usePendingSlotChange(studentId: string | number | null | undefined): {
    pending: UISlotChangePending | null
    refresh: () => void
} {
    const [pending, setPending] = useState<UISlotChangePending | null>(null)
    const key = studentId == null ? null : String(studentId)
    const { fetch } = useApiFetch<{ pending?: ApiSlotChangePending | null }>({
        service: studentSlotChangeService.getPendingStudentSlotChange,
        requestKey: key,
        enabled: key != null,
        fetchOnMount: false,
        idleOnError: true,
        onSuccess: (data) => setPending(toUISlotChangePending(data?.pending)),
    })

    // Un autre enfant n'a pas la demande du précédent.
    useEffect(() => setPending(null), [key])

    const refresh = useCallback(() => {
        if (key != null) fetch()
    }, [fetch, key])

    useFocusEffect(refresh)

    return { pending, refresh }
}
